import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './ToolCallIndicator.css';

const ToolCallIndicator = ({ toolCalls }) => {
  // States for animation (disabled for debugging)
  // const [isVisible, setIsVisible] = useState(true);
  // const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    // Disable auto-dismiss for debugging - indicator stays visible
    // const dismissTimer = setTimeout(() => {
    //   setIsAnimating(false);
    //   setTimeout(() => setIsVisible(false), 300); // Wait for exit animation
    // }, 4000);

    // return () => clearTimeout(dismissTimer);
    
    console.log('[TOOL CALL - INDICATOR RENDER] Component rendering:', {
      toolCount: toolCalls.length,
      message: getActivityMessage()
    });
  }, [toolCalls.length]);

  if (!toolCalls || toolCalls.length === 0) return null;

  const toolCount = toolCalls.length;
  const getActivityMessage = () => {
    if (toolCount === 1) return 'Using 1 tool';
    if (toolCount === 2) return 'Using 2 tools';
    if (toolCount === 3) return 'Using 3 tools';
    return `Using ${toolCount} tools`;
  };

  return (
    <div className="tool-call-indicator animate-in">
      <div className="indicator-content">
        <div className="activity-dots">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
        <span className="activity-text">{getActivityMessage()}</span>
      </div>
    </div>
  );
};

ToolCallIndicator.propTypes = {
  toolCalls: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      function: PropTypes.shape({
        name: PropTypes.string.isRequired,
        arguments: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      })
    })
  )
};

export default ToolCallIndicator;